import { render, staticRenderFns } from "./LocationTransportAccessibilityBlock.vue?vue&type=template&id=c183c882&scoped=true&"
import script from "./LocationTransportAccessibilityBlock.vue?vue&type=script&lang=js&"
export * from "./LocationTransportAccessibilityBlock.vue?vue&type=script&lang=js&"
import style0 from "./LocationTransportAccessibilityBlock.vue?vue&type=style&index=0&id=c183c882&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c183c882",
  null
  
)

export default component.exports